module.exports = __webpack_public_path__ + "static/media/amanda.50437272.jpeg";